import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AttendPage from "./pages/AttendPage";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/attend/:token" element={<AttendPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
